import { computeSensorLabel } from "@/models/equipment/sensors/properties";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderSensorCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "SENSOR",
    label: "Sensor Description",
    targetUnit: null,
    value:
      scenario.scenario.value?.equipment?.r_sensor &&
      computeSensorLabel(scenario.scenario.value?.equipment?.r_sensor)
  },
  {
    section: "SENSOR",
    label: "Sensor Length",
    targetUnit: targetUnits.largeLengthUnit,
    value: calcs.equipmentLengths.sensorLengthFt
  },
  {
    section: "SENSOR",
    label: "Sensor Weight",
    targetUnit: targetUnits.massUnit,
    value: calcs.equipmentWeights.sensorWeightLbs
  }
];
